// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import JsonExcel from 'vue-json-excel'

import 'element-ui/lib/theme-chalk/index.css'  //引入element-ui样式



Vue.config.productionTip = false
Vue.use(ElementUI);

import './style/theme/index.css'
import globals from './data.js'
import table from './table.js'
//配置全局
Vue.prototype.$globals = globals;

Vue.component('downloadExcel', JsonExcel)

import VueSession from 'vue-session'
Vue.use(VueSession)



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js